import Icon from '@/components/common/iconedLinks/Icon';
import { URLS } from '@/constants/urls';
import React from 'react';
import { useTranslation } from 'next-i18next';

import styles from './virtual-assistant-shortcut.module.scss';
import { startAssistantConversation } from '@/redux/slices/assistant.slice';
import { useAppDispatch } from '@/redux';

export const VirtualAssistantShortcut = ({ withLabel = false }) => {
  const t = useTranslation('alter').t;
  const tCommon = useTranslation('common').t;

  const dispatch = useAppDispatch();

  return (
    <div
      id="virtual-assistant"
      className={styles.container}
      onClick={() => dispatch(startAssistantConversation())}
    >
      <div className={styles['virtual-assistant-shortcut']}>
        <Icon src={URLS.SPARKLES_STARS_PURPLE} alt={t('icon')} height={16} width={16} />
      </div>
      {withLabel && (
        <p>{tCommon('assistant.shortcut')}</p>
      )}
    </div>
  );
};
